import * as React from 'react';
import { Field, observer, useField, useForm, } from '@formily/react';
import { CnFormItem } from '@/form/cn-form-item';
import { mapSize, mapStatus } from '@/form/__builtins__';
export const CnFormField = (props) => {
    const { children, tip, ...otherProps } = props;
    const form = useForm();
    React.useEffect(() => {
        if (otherProps.name) {
            form.setFieldState(otherProps.name, (state) => {
                state.setDataSource(children.props);
            });
        }
    }, [children.props]);
    if (children) {
        return (React.createElement(Field, { decorator: [
                CnFormItem,
                {
                    tip,
                },
            ], ...otherProps, component: [
                observer((childProps) => {
                    const childrenProps = childProps?.props || {};
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    const field = useField();
                    const { state } = mapStatus(childrenProps, field);
                    const { size } = mapSize(childrenProps);
                    return React.cloneElement(children, {
                        ...field.dataSource,
                        insideForm: true,
                        formLabel: field.props.title,
                        field,
                        state,
                        size,
                        disabled: field.disabled,
                        readOnly: field.readOnly,
                        value: field.value,
                        onChange: field.onInput,
                        onBlur: field.onBlur,
                        onFocus: field.onFocus,
                    });
                }),
            ], dataSource: children.props }));
    }
    return React.createElement(Field, { decorator: [CnFormItem], ...otherProps });
};
